/* eslint-disable import/prefer-default-export */
export const START_ADD_DEDICATED = 'START_ADD_DEDICATED';
export const STOP_ADD_DEDICATED = 'STOP_ADD_DEDICATED';
export const GET_DEDICATED_CUSTOMERS = 'GET_DEDICATED_CUSTOMERS';
